import { NavLink } from 'react-router-dom';
import {
  GlobeAltIcon,
  ArrowUpTrayIcon,
  FilmIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';

const navItems = [
  { to: '/discover', label: 'Discover', icon: GlobeAltIcon },
  { to: '/upload', label: 'Upload', icon: ArrowUpTrayIcon },
  { to: '/studio', label: 'Studio', icon: FilmIcon },
  { to: '/settings', label: 'Settings', icon: Cog6ToothIcon },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-midnight-bg border-t border-midnight-border safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-3 py-2 transition-colors ${
                isActive ? 'text-accent' : 'text-text-tertiary'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="text-xs">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
